import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { HttpRequestsService, RequestParam } from '@core/services/http-requests/http-requests.service';

@Injectable()
export class ApiChatService {
    constructor(private readonly http: HttpClient, private readonly requestService: HttpRequestsService) {}

    public workgroup(storeId: string, langId: string): Observable<any> {
        const slug = `store/${storeId}/workgroup`;
        const params: RequestParam[] = [
            { key: 'channel', value: 'chat' },
            { key: 'applyExceptions', value: 'true' },
        ];
        const url = this.requestService.requestUrl(slug, langId, params, undefined, undefined, 'integration/chat');
        return this.http.get(url).pipe(
            map((data: any[]) => this.filterWorkgroupByLang(data, langId)),
        );
    }

    private filterWorkgroupByLang(data: any, langId: any) {
        return data.find(d => Number(d.languageId) === Number(langId));
    }
}
